import $ from 'jquery';

$(function () {
  const TableOptions = window.TableOptions;

  $('#search_hierarchy').change(function () {
    window.location.href = '/FleetDASH/organizations/' + TableOptions.organizationId + '?hierarchy_id=' + $(this).val();
  });
});
